<form [formGroup]="form" (ngSubmit)="save()">
  <div class="modal-header">
    <h4 class="modal-title">Add Pickup Location</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancel()"
    ></button>
  </div>

  <div class="modal-body p-0 bst-pickup-location-form">
    <!-- Pickup -->
    <div class="pt-3 pb-3 ps-4 pe-4">
      <label class="form-label text-body1 d-flex align-items-center">
        <span class="badge bg-primary-light-950 me-2 d-flex">P</span>
        Select Pickup location (City - Morbi)*
      </label>

      <ng-select
        placeholder="Select Location"
        formControlName="pickupLocationId"
        [searchable]="true"
      >
        <ng-container *ngFor="let pickupLocation of userAddresses">
          <ng-option
            *ngIf="
              pickupLocationOptions.includes(pickupLocation?.city.toLowerCase())
            "
            [value]="pickupLocation.addressId"
          >
            <div class="user-name">
              <h5>{{ pickupLocation?.companyName }}</h5>
            </div>
          </ng-option>
        </ng-container>
      </ng-select>

      <div
        class="text-danger small mt-1"
        *ngIf="
          form.get('pickupLocationId')?.touched &&
          form.get('pickupLocationId')?.invalid
        "
      >
        Pickup is required
      </div>
    </div>
    <!-- /Pickup -->

    <hr />

    <!-- Deliveries list -->
    <div
      class="pt-3 pb-3 ps-4 pe-4"
      formArrayName="deliveries"
      *ngFor="
        let d of deliveriesFA.controls;
        let di = index;
        trackBy: trackByIndex
      "
    >
      <div class="d-flex justify-content-between align-items-center mb-2">
        <label class="form-label text-body1 d-flex align-items-center m-0">
          <span class="badge bg-primary-light-950 me-2 d-flex">D</span>
          Select Delivery location (City - Mumbai)*
        </label>

        <button
          *ngIf="deliveriesFA.controls.length > 1"
          type="button"
          class="btn-link btn-link-danger d-flex align-items-center text-body2 gap-1 p-0"
          (click)="removeDelivery(di)"
        >
          DELETE
        </button>
      </div>

      <div [formGroupName]="di">
        <!-- Delivery address (use companyAddresses) -->
        <ng-select
          placeholder="Select Location"
          formControlName="deliveryLocationId"
          [searchable]="true"
        >
          <ng-container *ngFor="let deliveryLocation of userAddresses">
            <ng-option
              *ngIf="
                deliveryLocationOptions.includes(
                  deliveryLocation?.city.toLowerCase()
                )
              "
              [value]="deliveryLocation.addressId"
            >
              <div class="user-name">
                <h5>{{ deliveryLocation?.companyName }}</h5>
              </div>
            </ng-option>
          </ng-container>
        </ng-select>

        <div
          class="text-danger small mt-1"
          *ngIf="
            deliveryCtrl(di, 'deliveryLocationId')?.touched &&
            deliveryCtrl(di, 'deliveryLocationId')?.invalid
          "
        >
          Pickup location is required.
        </div>

        <!-- Items (products) -->
        <div
          class="row g-2 mb-3 mt-2 align-items-start justify-content-between flex-nowrap"
          formArrayName="items"
          *ngFor="
            let item of itemsFA(di).controls;
            let ii = index;
            trackBy: trackByIndex
          "
        >
          <!-- Product -->
          <div class="col-lg-2" [formGroupName]="ii">
            <label class="form-label text-body1 d-block">Select Product</label>

            <ng-select
              placeholder="Select"
              formControlName="productId"
              [searchable]="true"
            >
              <ng-option
                *ngFor="let product of productData"
                [value]="product._id"
              >
                <div class="user-name">
                  <h5>{{ product?.name }}</h5>
                </div>
              </ng-option>
            </ng-select>

            <div
              class="text-danger small"
              *ngIf="
                itemsFA(di).at(ii).get('productId')?.touched &&
                itemsFA(di).at(ii).get('productId')?.invalid
              "
            >
              Product is required.
            </div>
          </div>

          <!-- Sub-item (Size) -->
          <div class="col-lg-2" [formGroupName]="ii">
            <label class="form-label text-body1 d-block">Size</label>

            <ng-select
              placeholder="Select"
              formControlName="subItemId"
              [items]="getSubItems(itemsFA(di).at(ii).get('productId')?.value)"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              [clearable]="true"
            >
              <ng-template ng-option-tmp let-item="item">
                <div class="user-name">
                  <h5>{{ item.name }}</h5>
                </div>
              </ng-template>
            </ng-select>

            <div
              class="text-danger small"
              *ngIf="
                itemsFA(di).at(ii).get('subItemId')?.enabled &&
                itemsFA(di).at(ii).get('subItemId')?.touched &&
                itemsFA(di).at(ii).get('subItemId')?.invalid
              "
            >
              Size is required.
            </div>
          </div>

          <!-- Quantity -->
          <div class="col-lg-3" [formGroupName]="ii">
            <label class="form-label text-body1 d-block">Quantity (Box)</label>
            <input
              type="number"
              class="form-control text-body1"
              placeholder="Enter Quantity"
              formControlName="quantityBox"
              min="0"
            />
            <div
              class="text-danger small"
              *ngIf="
                itemsFA(di).at(ii).get('quantityBox')?.touched &&
                itemsFA(di).at(ii).get('quantityBox')?.invalid
              "
            >
              Quantity is required.
            </div>
          </div>

          <!-- Weight -->
          <div class="col-lg-3" [formGroupName]="ii">
            <label class="form-label text-body1 d-block">Weight (KG)</label>
            <input
              type="number"
              class="form-control text-body1"
              placeholder="Enter Weight"
              formControlName="weightKg"
              min="0"
            />
            <div
              class="text-danger small"
              *ngIf="
                itemsFA(di).at(ii).get('weightKg')?.touched &&
                itemsFA(di).at(ii).get('weightKg')?.invalid
              "
            >
              Weight is required and must be &gt; 0.
            </div>
          </div>

          <!-- Action -->
          <div class="col-lg-2 d-flex flex-column">
            <label class="form-label text-body1">Action</label>
            <button
              *ngIf="itemsFA(di).controls.length > 1"
              type="button"
              class="delete-btn rounded"
              (click)="removeItem(di, ii)"
            >
              <!-- trash icon -->
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H9C9 3.71667 9.09583 3.47917 9.2875 3.2875C9.47917 3.09583 9.71667 3 10 3H14C14.2833 3 14.5208 3.09583 14.7125 3.2875C14.9042 3.47917 15 3.71667 15 4H19C19.2833 4 19.5208 4.09583 19.7125 4.2875C19.9042 4.47917 20 4.71667 20 5C20 5.28333 19.9042 5.52083 19.7125 5.7125C19.5208 5.90417 19.2833 6 19 6V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM10 17C10.2833 17 10.5208 16.9042 10.7125 16.7125C10.9042 16.5208 11 16.2833 11 16V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V16C9 16.2833 9.09583 16.5208 9.2875 16.7125C9.47917 16.9042 9.71667 17 10 17ZM14 17C14.2833 17 14.5208 16.9042 14.7125 16.7125C14.9042 16.5208 15 16.2833 15 16V9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8C13.7167 8 13.4792 8.09583 13.2875 8.2875C13.0958 8.47917 13 8.71667 13 9V16C13 16.2833 13.0958 16.5208 13.2875 16.7125C13.4792 16.9042 13.7167 17 14 17Z"
                  fill="#F04438"
                />
              </svg>
            </button>
          </div>
        </div>

        <button
          type="button"
          class="btn-link btn-link-primary d-flex align-items-center text-body2 gap-1 p-0"
          (click)="addItem(di)"
        >
          ADD PRODUCT
        </button>
      </div>

      <hr *ngIf="di < deliveriesFA.length - 1" />
    </div>
    <!-- /Deliveries -->
  </div>

  <div class="modal-footer">
    <div class="d-flex align-items-center justify-content-between w-100">
      <a
        class="btn btn-light d-flex align-items-center justify-content-center gap-1"
        (click)="addDelivery()"
      >
        ADD Pickup LOCATION
      </a>
      <button
        class="btn btn-primary"
        [disabled]="isViewMode || form.invalid"
        type="submit"
      >
        Save
      </button>
    </div>
  </div>
</form>
